import { ToastStateHandler } from '../../api';
import { PolicyDto } from '../../commonTypes/leaveRequest.types';

export class PolicyHandler {
    constructor(private readonly toastHandler: ToastStateHandler, private readonly languageData: any) {}

    public policyCreationSucceeded(body: any): void {
        const policy: PolicyDto = body;
        if (!policy.id) return;
        this.toastHandler.push(
            'success',
            this.languageData.createPolicy.notifications.suceededNotificationTitle,
            this.languageData.createPolicy.notifications.succededNotificationMessage
        );
    }

    public policyCreationFailed = (body: any) => {
        const policy: PolicyDto = body;
        if (!policy.id) return;
        this.toastHandler.push(
            'error',
            this.languageData.createPolicy.notifications.failedNotificationTitle,
            this.languageData.createPolicy.notifications.failedNotificationMessage
        );
    };

    public policyMembersChangeFailed = () => {
        this.toastHandler.push(
            'error',
            this.languageData.addEditPolicy.wsNotifications.POLICY_MEMBERS_CHANGE_FAILED_TITLE,
            this.languageData.addEditPolicy.wsNotifications.POLICY_MEMBERS_CHANGE_FAILED_MESSAGE
        );
    };

    public policyNameUpdated = () => {
        this.toastHandler.push(
            'success',
            this.languageData.addEditPolicy.wsNotifications.POLICY_NAME_UPDATED_TITLE,
            this.languageData.addEditPolicy.wsNotifications.POLICY_NAME_UPDATED_MESSAGE
        );
    };
}
